<template>
  <main class="p-error l-page">
    <section class="p-error__wrap">
      <h2 class="c-regist__title">{{ t(title) }}</h2>
      <p class="c-regist__comment message">{{ t(message) }}</p>
      <ul
        v-if="JSON.parse(t(descriptions)) && JSON.parse(t(descriptions)).length > 0"
        class="p-error__notes"
      >
        <li
          v-for="index in JSON.parse(t(descriptions))"
          :key="`description_${index}`"
          class="p-error__note"
        >
          {{ index }}
        </li>
      </ul>
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import StoreUtil from '@/stores/StoreUtil'

export default defineComponent({
  name: 'ErrorPage',
  setup() {
    const { t } = useI18n()
    const ErrorStore = StoreUtil.useStore('ErrorStore')
    onMounted(async () => {
      console.warn()
    })
    return {
      t,
      title: ErrorStore.title,
      message: ErrorStore.message,
      descriptions: ErrorStore.descriptions,
    }
  },
  components: {},
})
</script>

<style scoped lang="scss"></style>
